module.exports = __webpack_public_path__ + "entypo.5460a9ba11448e34f332.woff";


//////////////////
// WEBPACK FOOTER
// /Users/dani/apps/WebTerminalEN/src/assets/Theme/fonts/entypo.woff
// module id = ../../../../../src/assets/Theme/fonts/entypo.woff
// module chunks = 1